const adaptData = ({ title }) => {
    return {
        title: `${title}`
    }
};

export default adaptData;
